const listeners = new Set();

export const toastManager = {
  _emit(type, message) {
    listeners.forEach((fn) => fn({ type, message }));
  },
  success(msg) { this._emit("success", msg); },
  error(msg) { this._emit("error", msg); },
  warn(msg) { this._emit("warning", msg); },
  info(msg) { this._emit("info", msg); },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
};
